import classes from "../../pages/main/main.module.css";
import React from "react";

export const PhotoUpdater = ({onClick}) => {
    return (
        <div className={classes.overlay} onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 24 24" fill="none"
                 aria-hidden="true">
                <g stroke="#349EFF"
                   strokeWidth="1.6"
                   strokeLinecap="round"
                   strokeLinejoin="round" fill="none">
                    <path
                        d="M3 7.5h3l1.5-2h8L18 7.5h3a1 1 0 0 1 1 1V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.5a1 1 0 0 1 1-1z"/>
                    <circle cx="12" cy="13.5" r="3.5"/>
                </g>
            </svg>

        </div>
    )
}